import jwt_decode from "jwt-decode";

export default {
  methods: {
    /**
     * Método generico para recuperar el id interno del sistema (LTI) del usuario logado del JWT
     */
    jwtLoggedUserId() {
      const token = window.$cookies.get("LTI_JWT");
      if (token) {
        try {
          let jwtDecoded = jwt_decode(token);
          return jwtDecoded.user;
        } catch (e) {
          return null;
        }
      }
      return null;
    },
    /**
     * Método generico para recuperar el nombre de la asignatura
     */
    jwtContextTitle() {
      const token = window.$cookies.get("LTI_JWT");
      if (token) {
        try {
          let jwtDecoded = jwt_decode(token);
          let response = jwtDecoded.contextTitle;
          return response;
        } catch (e) {
          return null;
        }
      }
      return null;
    },
    /**
     * Normaliza caracters especiales a UTF8
     *
     * @param {*} str
     * @returns
     */
    toUTF8(str) {
      if (!str) return "";
      return str
        .replaceAll("Ã", "Á")
        .replaceAll("Ã¡", "á")
        .replaceAll("Ã‰", "É")
        .replaceAll("Ã©", "é")
        .replaceAll("Ã", "Í")
        .replaceAll("Ã­", "í")
        .replaceAll("Ã“", "Ó")
        .replaceAll("Ã", "Ó")
        .replaceAll("Ã³", "ó")
        .replaceAll("Ãš", "Ú")
        .replaceAll("Ãº", "ú")
        .replaceAll("Ã‘", "Ñ")
        .replaceAll("Ã±", "ñ")
        .replaceAll("Â¿", "¿")
        .replaceAll("Ã¼", "ü")
        .replaceAll("Ãœ", "Ü");
    },
    jwtGetUserName() {
      const token = window.$cookies.get("LTI_JWT");
      if (token) {
        try {
          let jwtDecoded = jwt_decode(token);
          return jwtDecoded.userName;
        } catch (e) {
          return null;
        }
      }
      return null;
    },

    jwtUnirId() {
      const token = window.$cookies.get("LTI_JWT");
      if (token) {
        try {
          let jwtDecoded = jwt_decode(token);
          return jwtDecoded.userUnir;
        } catch (e) {
          return null;
        }
      }
      return null;
    },
    jwtEmail() {
      const token = window.$cookies.get("LTI_JWT");
      if (token) {
        try {
          let jwtDecoded = jwt_decode(token);
          return jwtDecoded.email;
        } catch (e) {
          return null;
        }
      }
      return null;
    },
    /**
     * Método generico para recuperar el color principal asociado a la licencia LTI
     */
    jwtPrimaryColor() {
      const token = window.$cookies.get("LTI_JWT");

      if (token) {
        try {
          let jwtDecoded = jwt_decode(token);
          return jwtDecoded.primaryColor;
        } catch (e) {
          return null;
        }
      }
      return null;
    },
    /**
     * Método generico para recuperar el color secundario asociado a la licencia LTI
     */
    jwtSecondaryColor() {
      const token = window.$cookies.get("LTI_JWT");

      if (token) {
        try {
          let jwtDecoded = jwt_decode(token);
          return jwtDecoded.secondaryColor;
        } catch (e) {
          return null;
        }
      }
      return null;
    },
    /**
     * Método generico para recuperar la fuente de texto asociado a la licencia LTI
     */
    jwtFont() {
      const token = window.$cookies.get("LTI_JWT");

      if (token) {
        try {
          let jwtDecoded = jwt_decode(token);
          return jwtDecoded.font;
        } catch (e) {
          return null;
        }
      }
      return null;
    },
    /**
     * Método generico para recuperar el id en el LMS del usuario logado del JWT
     */
    jwtLoggedUserLmsId() {
      const token = window.$cookies.get("LTI_JWT");

      if (token) {
        try {
          let jwtDecoded = jwt_decode(token);
          return jwtDecoded.userLms;
        } catch (e) {
          return null;
        }
      }
      return null;
    },
    /**
     * Método generico para recuperar el id interno del sistema (LTI) del usuario logado del JWT
     */
    jwtConsumerId() {
      const token = window.$cookies.get("LTI_JWT");

      if (token) {
        try {
          let jwtDecoded = jwt_decode(token);
          return jwtDecoded.consumer;
        } catch (e) {
          return null;
        }
      }
      return null;
    },
    /**
     * Método generico para recuperar el id interno del sistema (LTI) del site desde el que se accede del JWT
     */
    jwtContextSite() {
      const token = window.$cookies.get("LTI_JWT");

      if (token) {
        try {
          let jwtDecoded = jwt_decode(token);
          return jwtDecoded.context;
        } catch (e) {
          return null;
        }
      }
      return null;
    },
    /**
     * Método generico para recuperar la lista los roles del usuario logado del JWT
     */
    jwtLoggedUserRoles() {
      const token = window.$cookies.get("LTI_JWT");

      if (token) {
        try {
          let jwtDecoded = jwt_decode(token);
          return jwtDecoded.roleUnir;
        } catch (e) {
          return [];
        }
      }
      return [];
    },

    /**
     * Método generico para recuperar el rol del usuario logado del JWT
     */
    jwtLoggedUserRole() {
      const token = window.$cookies.get("LTI_JWT");

      if (token) {
        try {
          let jwtDecoded = jwt_decode(token);
          return jwtDecoded.role;
        } catch (e) {
          return [];
        }
      }
      return [];
    },
    /**
     * Método generico para recuperar la instancia de connect asociada a la licencia para la creación manual de sesiones
     */
    jwtDefaultAcInstance() {
      const token = window.$cookies.get("LTI_JWT");

      if (token) {
        try {
          let jwtDecoded = jwt_decode(token);
          return jwtDecoded.consumerAcInstance;
        } catch (e) {
          return [];
        }
      }
      return [];
    },
    /**
     * Método generico para recuperar el idioma en la plataforma
     */
    jwtLanguage() {
      const token = window.$cookies.get("LTI_JWT");

      if (token) {
        try {
          let jwtDecoded = jwt_decode(token);
          return jwtDecoded.language || "es";
        } catch (e) {
          return "es";
        }
      }
      return "es";
    },
  },
};
